import React from 'react';

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Space+Grotesk:wght@500;600;700&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    :root{
      --bg:#F8FAFC;
      --surface:#FFFFFF;
      --surface-container-low:#F1F5F9;
      --surface-container-lowest:#FFFFFF;
      --surface-container-highest:#E2E8F0;
      --primary:#3B82F6;
      --secondary:#00D8FF;
      --tertiary:#8B5CF6;
      --outline-variant:rgba(25, 28, 30, 0.15);
      --on-surface:#191C1E;
      --on-surface-variant:#475569;
      --slate-900:#0F172A;
      --slate-800:#1E293B;
      --slate-700:#334155;
      --slate-600:#475569;
      --slate-500:#64748B;
      --slate-400:#94A3B8;
      --slate-200:#E2E8F0;
      --slate-100:#F1F5F9;
      --green:#10B981;
      --green-light:rgba(16, 185, 129, 0.08);
      --red:#EF4444;
      --amber:#F59E0B;
      --cyan-dim:#006571;
      --border:rgba(25, 28, 30, 0.08);
      --shadow-ambient:0px 12px 32px rgba(25, 28, 30, 0.06);
      --shadow-sm:0px 4px 12px rgba(25, 28, 30, 0.03);
      --glass-blur:20px;
      --grad-synapse:linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
      --grad-hero:linear-gradient(160deg, #F1F5F9 0%, var(--bg) 40%, #EFF6FF 100%);
      --font:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
      --font-display:'Space Grotesk',sans-serif;
      --ls-tight:-0.02em;
      --radius-sm: 8px;
      --radius-md: 12px;
      --radius-lg: 16px;
      --radius-xl: 24px;
    }
    html{scroll-behavior:smooth}
    body{font-family:var(--font);background:var(--bg);color:var(--on-surface);line-height:1.6;-webkit-font-smoothing:antialiased;overflow-x:hidden}
    
    @keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
    @keyframes fadeIn{from{opacity:0}to{opacity:1}}
    @keyframes scaleIn{from{opacity:0;transform:scale(.98)}to{opacity:1;transform:scale(1)}}
    @keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
    @keyframes techBannerScroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}
    @keyframes toastIn{from{opacity:0;transform:translate(-50%,-12px)}to{opacity:1;transform:translate(-50%,0)}}
    @keyframes pulseLine{from{width:0;opacity:0}to{width:100%;opacity:1}}

    .au{animation:fadeUp .7s cubic-bezier(.16,1,.3,1) both}
    .af{animation:fadeIn .5s ease both}
    .asc{animation:scaleIn .4s cubic-bezier(.16,1,.3,1) both}
    .d1{animation-delay:.1s}.d2{animation-delay:.2s}.d3{animation-delay:.3s}

    .glass-nav{background:rgba(248,250,252,.75);backdrop-filter:blur(var(--glass-blur));box-shadow:var(--shadow-sm);border-bottom:1px solid rgba(25, 28, 30, 0.05)}
    .glass-nav-solid{background:rgba(248,250,252,.95);backdrop-filter:blur(var(--glass-blur));box-shadow:var(--shadow-ambient);border-bottom:1px solid rgba(25, 28, 30, 0.1)}
    

    
    
    .hide-m{display:block}
    .show-m{display:none}
    
    /* NO-LINE ARCHITECTURE */
    .card{background:var(--surface-container-lowest);border:none;border-radius:var(--radius-md);box-shadow:var(--shadow-sm);transition:all .4s cubic-bezier(.16,1,.3,1)}
    .card:hover{box-shadow:var(--shadow-ambient);transform:translateY(-4px)}
    .cs{background:var(--surface-container-low);border:none;border-radius:var(--radius-md)}
    
    .form-card {
      padding: 40px;
    }
    @media(max-width:768px) {
      .form-card {
        padding: 24px 20px;
      }
    }

    .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:var(--font);font-weight:600;font-size:14px;border-radius:var(--radius-md);cursor:pointer;border:none;transition:all .3s cubic-bezier(.16,1,.3,1);padding:12px 24px;white-space:nowrap;text-decoration:none;position:relative}
    .btn:active{transform:translateY(1px) scale(.98)}
    .btn-primary{background:var(--grad-synapse);color:#fff}
    .btn-primary:hover{transform:translateY(2px);box-shadow:var(--shadow-ambient)}
    .btn-outline{background:transparent;color:var(--primary);outline:1px solid var(--outline-variant)}
    .btn-outline:hover{background:rgba(59,130,246,.05);outline-color:var(--primary);transform:translateY(2px)}
    .btn-ghost{background:transparent;color:var(--on-surface-variant)}
    .btn-ghost:hover{background:var(--surface-container-low);color:var(--on-surface);transform:translateY(2px)}
    .btn-white{background:#fff;color:var(--primary);box-shadow:var(--shadow-sm)}
    .btn-white:hover{box-shadow:var(--shadow-ambient);transform:translateY(2px)}
    .btn-lg{padding:16px 36px;font-size:15px}
    .btn-sm{padding:8px 16px;font-size:13px}

    .badge{display:inline-flex;align-items:center;gap:6px;font-size:10.5px;font-weight:700;padding:5px 14px;border-radius:var(--radius-sm);letter-spacing:.05em;text-transform:uppercase;background:var(--tertiary);color:#fff}
    .bb{background:rgba(59,130,246,.08);color:var(--primary)}
    .bp{background:rgba(139,92,246,.08);color:var(--tertiary)}
    .bt{background:var(--tertiary);color:#fff}

    .eyebrow{display:inline-flex;align-items:center;gap:12px;font-family:var(--font-display);font-size:11px;font-weight:700;letter-spacing:.15em;text-transform:uppercase;color:var(--primary);margin-bottom:16px}
    
    .lbl{display:block;font-size:12.5px;font-weight:600;color:var(--slate-600);margin-bottom:8px;letter-spacing:.01em}
    .inp-container{position:relative;background:var(--surface-container-highest);border-radius:var(--radius-md);overflow:hidden}
    .inp{width:100%;font-family:var(--font);font-size:14.5px;color:var(--on-surface);background:transparent;border:none;padding:14px 18px;outline:none;transition:all .3s}
    .inp-pulse{position:absolute;bottom:0;left:50%;height:2px;background:var(--primary);width:0;transform:translateX(-50%);transition:all .4s cubic-bezier(.16,1,.3,1);opacity:0}
    .inp:focus + .inp-pulse{width:100%;opacity:1}
    
    .inp-icon{padding-left:46px!important}
    .err{background:rgba(239,68,68,0.05)!important}

    .nav-item{font-family:var(--font);font-size:14px;font-weight:500;color:var(--on-surface-variant);background:none;border:none;cursor:pointer;padding:8px 16px;transition:all .2s;border-radius:var(--radius-sm);text-decoration:none}
    .nav-item:hover{color:var(--primary);background:rgba(59,130,246,.06)}
    .nav-item.active{color:var(--primary);font-weight:700;background:rgba(59,130,246,.1)}

    .gtext{background:var(--grad-synapse);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
    .blob{border-radius:60% 40% 30% 70%/60% 30% 70% 40%;animation:blobMove 8s ease-in-out infinite}
    @keyframes blobMove{0%,100%{border-radius:60% 40% 30% 70%/60% 30% 70% 40%}50%{border-radius:30% 60% 70% 40%/50% 60% 30% 60%}}

    .ticker-item{display:inline-flex;align-items:center;gap:16px;padding:0 56px;font-family:var(--font-display);font-size:11px;font-weight:700;color:var(--slate-400);letter-spacing:.25em;text-transform:uppercase}

    .prog-track{width:100%;height:6px;background:var(--slate-100);border-radius:10px;overflow:hidden}
    .prog-fill{height:100%;background:var(--grad-synapse);border-radius:10px;transition:width .8s cubic-bezier(.16,1,.3,1)}

    .g2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 32px; }
    .g3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px; }
    .g4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
    .g5c { display: grid; grid-template-columns: 1.5fr 1fr; gap: 100px; align-items: center; }
    
    .founders-grid { display: flex; flex-wrap: wrap; justify-content: center; gap: 32px; }
    .founders-grid > div { width: calc((100% - 64px) / 3); }
    
    .founder-card { display: flex; flex-direction: column; }
    .founder-card.text-bottom { flex-direction: column-reverse; }
    .founder-card.align-right .founder-text { text-align: right; }

    @media(max-width:768px){
      main { padding-top: 80px; }
      section{padding-top:60px!important;padding-bottom:60px!important}
      .hide-m{display:none!important}
      .show-m{display:flex!important}
      .btn-lg{padding:14px 28px; width: 100%;}
      .g2, .g3, .g4, .g5c, .membership-grid, .blog-grid, .legal-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
      .footer-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
      .ev-detail-grid { grid-template-columns: 1fr !important; gap: 16px !important; }
      .founders-grid > div { width: 100% !important; }
      .founder-card.text-bottom { flex-direction: column !important; }
      .founder-card.align-right .founder-text { text-align: left !important; }
      
      h1 { font-size: clamp(32px, 10vw, 48px) !important; }
      h2 { font-size: clamp(28px, 8vw, 36px) !important; }
      .show-m-stack { grid-template-columns: 1fr !important; gap: 8px !important; }
      .show-m-stack button { margin-top: 0 !important; margin-bottom: 0 !important; }
    }

    .toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:9999;display:flex;align-items:center;gap:12px;padding:12px 20px;background:var(--on-surface);color:#fff;border-radius:var(--radius-md);box-shadow:0 12px 32px rgba(0,0,0,.15);animation:toastIn .4s cubic-bezier(.16,1,.3,1) both;min-width:300px}
    @media(max-width: 480px) {
      .toast { width: calc(100% - 32px); bottom: 16px; min-width: 0; }
    }
  `}</style>
);

export default GlobalStyles;
